import {ReactElement} from "react"

const FriendIcon = (): ReactElement => {
	return (
    <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.4167 15.75V14.0833C17.4167 12.5301 16.3544 11.2251 14.9167 10.855M12 0.992299C13.2216 1.48679 14.0833 2.68443 14.0833 4.08333C14.0833 5.48224 13.2216 6.67988 12 7.17437M13.25 15.75C13.25 14.1969 13.25 13.4203 12.9963 12.8077C12.658 11.991 12.009 11.342 11.1923 11.0037C10.5797 10.75 9.80314 10.75 8.25 10.75H5.75C4.19686 10.75 3.42029 10.75 2.80772 11.0037C1.99096 11.342 1.34205 11.991 1.00373 12.8077C0.75 13.4203 0.75 14.1969 0.75 15.75M10.3333 4.08333C10.3333 5.92428 8.84095 7.41667 7 7.41667C5.15905 7.41667 3.66667 5.92428 3.66667 4.08333C3.66667 2.24238 5.15905 0.75 7 0.75C8.84095 0.75 10.3333 2.24238 10.3333 4.08333Z"
        stroke="#17253C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default FriendIcon
